import { checkoutWidgetWithAssignmentsSchema } from "@redotech/redo-model/checkouts/checkout-widget";
import * as z from "zod/v4";

export const getCheckoutWidgets = {
  name: "getCheckoutWidgets" as const,
  input: z.object({}),
  output: z.array(checkoutWidgetWithAssignmentsSchema),
};
